var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommsDelay = function SvgCommsDelay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "comms-delay_svg2__a",
    x1: 29.45,
    x2: 140.13,
    y1: 179.41,
    y2: 73.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms-delay_svg2__a",
    id: "comms-delay_svg2__b",
    x1: -2.81,
    x2: 107.87,
    y1: 145.78,
    y2: 39.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms-delay_svg2__a",
    id: "comms-delay_svg2__c",
    x1: 65.04,
    x2: 175.72,
    y1: 216.53,
    y2: 110.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms-delay_svg2__a",
    id: "comms-delay_svg2__d",
    x1: 70.8,
    x2: 181.48,
    y1: 222.52,
    y2: 116.36
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.31 100.42h-1.38c.64-4.28.96-8.62.96-12.97C174.9 39.23 135.67 0 87.45 0S0 39.23 0 87.45s39.23 87.45 87.45 87.45c4.35 0 8.69-.33 12.97-.96v20.21c0 3.11 2.51 5.86 5.86 5.86 1.14 0 2.27-.33 3.25-.98l17.35-11.57h48.43c13.61 0 24.69-11.07 24.69-24.69v-37.66c0-13.61-11.07-24.69-24.69-24.69m-74.89 24.68v36.96c-4.26.74-8.61 1.11-12.97 1.11-41.76 0-75.73-33.97-75.73-75.73s33.97-75.72 75.73-75.72 75.73 33.97 75.73 75.73c0 4.36-.38 8.71-1.11 12.97h-36.96c-13.64 0-24.69 11.03-24.69 24.69Zm87.86 37.66c0 7.15-5.82 12.97-12.97 12.97H125.1c-1.16 0-2.29.34-3.25.98l-9.72 6.48V125.1c0-7.17 5.8-12.97 12.97-12.97h50.21c7.15 0 12.97 5.82 12.97 12.97z",
    style: {
      fill: "url(#comms-delay_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45 25.1c-3.24 0-5.86 2.62-5.86 5.86v50.63h-31.8c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h37.66c3.23 0 5.86-2.62 5.86-5.86V30.96c0-3.24-2.62-5.86-5.86-5.86",
    style: {
      strokeWidth: 0,
      fill: "url(#comms-delay_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81 129.78h-43c-2.21 0-4 1.79-4 4s1.79 4 4 4h43c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      strokeWidth: 0,
      fill: "url(#comms-delay_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.54 150.78h-22.23c-2.21 0-4 1.79-4 4s1.79 4 4 4h22.23c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      strokeWidth: 0,
      fill: "url(#comms-delay_svg2__d)"
    }
  }));
};
export default SvgCommsDelay;